<template>
    <div class="container container--narrow pdt-30 pdb-26">

                <div class="mdc-card  mgb-24 pdb-8" v-if="completionData">
                    <div class="t-headline7 font-m  mgb-16 mgr-12 pdt-24 pdl-24">{{$t('685')}}</div>
                    <div class="pdl-24 pdr-24 pdt-16 pdb-16">
                        <div class="d-flex">
                            <img src="/img/clipboard-pulse.svg" alt="" class="w-18 h-18 mgr-16">
                            <div class="t-body1 font-r t-color-bodyGrayA pdl-16 l-spacing48 flex-grow-1">{{$t('686')}}</div>
                            <div class="t-body1 font-r">{{$t('687', {str: completionData.minRate})}}</div>
                        </div>

                    </div>

                    <div class="pdl-24 pdr-24 pdt-16 pdb-16" v-if="completionData && completionData.examScoreType" >
                        <div class="d-flex">
                            <img src="/img/pencil-box.svg" alt="" class="w-18 h-18 mgr-16">
                            <div class="t-body1 font-r t-color-bodyGrayA pdl-16 l-spacing48 flex-grow-1">{{$t('688')}}</div>
                            <div class="t-body1 font-r"> {{$t(completionData.examScoreType.translate)}}
                        {{$t('689', {str: completionData.examScore})}}</div>
                        </div>
                    </div>

                    <div class="pdl-24 pdr-24 pdt-16 pdb-16" v-if="completionData && completionData.askCount" >
                        <div class="d-flex">
                            <img src="/img/account-box.svg" alt="" class="w-18 h-18 mgr-16">
                            <div class="t-body1 font-r t-color-bodyGrayA pdl-16 l-spacing48 flex-grow-1">{{$t('690')}}</div>
                            <div class="t-body1 font-r">{{$t('691', {str: completionData.askCount})}}</div>
                        </div>
                    </div>

                </div>


                <div class="mdc-card  mgb-24" v-if="pointData" >
                    <div class="pda-24 d-flex justify-content-between align-items-center">
                        <div class="t-headline7 font-m ">{{$t('692')}}</div>
                        <div class="t-body1 font-rn">{{$t('693', {str: $n(pointData.earnPoint)})}}</div>
                    </div>
                </div>

                <div class="mdc-card  mgb-30 pdb-16" v-if="badgesData.length">
                    <div class="t-headline7 font-m  mgb-16 mgr-12 pdt-24 pdl-24">{{$t('694')}}</div>

                    <div class="pdl-24 pdr-24 pdt-8 pdb-8 d-flex align-items-center" v-for="(badge, index) in badgesData" :key="index" >
                        <img :src="badge.image" v-if="badge.image" alt="" class="icon52">
                        <div class="t-body1 font-r t-color-botyGrayA l-spacing48 pdl-20">
                            {{badge.name}}
                        </div>

                    </div>
                </div>
    </div>
</template>

<script>
/**
 * 차수 상세 라워드 탭 컴포넌트(degree view reward tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import degreeApi from '@/api/degreeApi.js'

export default {
    data() {
        return {
            completionData: null,
            pointData: null,
            badgesData: []
        }
    },

    mounted() {
        this.fetchData()
    },

    methods: {
        // 리워드정보 API 호출 및 데이터 설정(call api data)
        fetchData() {
            let responseData = null
            let params = this.setParams()

            // 수료조건(Completion)
            degreeApi.guestLearnOnlineViewCompletion(params).then((response) => {
                this.completionData = response.data.data
                
            }).catch((err) => {})

            // 포인트(point)
            degreeApi.guestLearnOnlineViewPoint(params).then((response) => {
                this.pointData = response.data.data
            }).catch((err) => {})

            // 배지(badge)
            degreeApi.guestLearnOnlineViewBadges(params).then((response) => {
                this.badgesData = response.data.data
            }).catch((err) => {})
        },
        
        // 파라미터 설정(set parameter)
        setParams() {
            const params = {
                degreeId: this.$route.params.degreeId
            }
            return params
        },
    }
}
</script>